import React from 'react';

const ManipulatingDom = () => (
    <section className='white-content'>
    ManipulatingDom
    </section>
)

export default ManipulatingDom;